
import Vue from 'vue'
import firebase from 'firebase/app'
import { Component, Prop, Emit } from 'vue-property-decorator'
import BrandLogo from '@/components/BrandLogo.vue'

@Component({
  components: {
    BrandLogo
  }
})
export default class VerifyPhone extends Vue {

  @Prop(String) public readonly phoneNumber: string | undefined

  public verificationSending = false
  public verificationSent = false
  public valid = false
  public saving = false
  public error = ''

  public retryTime = 30
  public retryTimeRemaining = 0
  private retryInterval: number | null = null

  public recaptchaVerifier!: firebase.auth.RecaptchaVerifier
  public confirmationResult: any
  public verificationCode = ''

  public showWelcomeScreen = false

  public $refs!: {
    smsVerify: Vue | HTMLButtonElement
  }

  public async mounted() {
    await this.$firebase
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        (this.$refs.smsVerify as Vue).$el as HTMLButtonElement,
        {size: 'invisible'}
    )
  }

  public async sendVerification() {
    if (this.phoneNumber) {
      try {
        this.verificationSending = true
        this.confirmationResult = await (await this.$firebase).auth().signInWithPhoneNumber(
            this.phoneNumber,
            this.recaptchaVerifier
        )
        this.verificationSending = false
        this.verificationSent = true
        this.startRetryTimer()
      } catch (error) {
        this.error = error
      }
    }
  }

  public async submit() {
    this.showWelcomeScreen = false
    this.error = ''
    this.saving = true
    try {
      const userCredential = await this.confirmationResult.confirm(this.verificationCode)
      this.verified(userCredential)
    } catch (error) {
      this.error = error.message
    }
    this.saving = false
  }

  @Emit()
  public verified(userCredential: firebase.auth.UserCredential) {
    return userCredential
  }

  private startRetryTimer() {
    this.retryTimeRemaining = this.retryTime
    this.retryInterval = window.setInterval(() => {
      if (this.retryTimeRemaining > 0) {
        --this.retryTimeRemaining
      } else {
        if (typeof this.retryInterval === 'number') {
          clearInterval(this.retryInterval)
          this.retryInterval = null
        }
      }
    }, 1000)
  }
}
